export default __webpack_public_path__ + "static/media/iconJava.fdabd4e1.png";